'use strict';

$(function() {
  function validatePhone(e) {
    var rxPhonePattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    var phoneNumber = $('.demographicsCustomerPhoneNumber').val();
    var phone = phoneNumber.match(rxPhonePattern);

    if (phone === null) {
      return false;
    }

    return true;
  }

  function formatPhoneNumber(phoneNumberString) {
    var phone = phoneNumberString.replace(/\D/g, '');
    var match = phone.match(/^(\d{1,3})(\d{0,3})(\d{0,4})$/);

    if (match) {
      phone = ''
        .concat(match[1])
        .concat(match[2] ? '.' : '')
        .concat(match[2])
        .concat(match[3] ? '.' : '')
        .concat(match[3]);
    }

    return phone;
  }
  var finalPhoneNumber = "";
  $(document).on(
    'keyup keypress',
    '.demographicsCustomerPhoneNumber',
    function(e) {
      var thisPhone = $(this);
      var curval = $(this).val();
      if(curval.length === 12 && curval.split('.').length === 2){
        curval = finalPhoneNumber;
      }
      var cursorPosition = e.target.selectionStart;
      var phoneLength = curval.length;
      thisPhone.val(formatPhoneNumber(curval));
      finalPhoneNumber = curval;
      if(e.target.selectionStart === e.target.selectionEnd){
       if(e.keyCode === 8 || e.keyCode === 127){
        thisPhone.focus();
        thisPhone[0].selectionStart = thisPhone[0].selectionEnd = cursorPosition;  
       } else if(phoneLength > cursorPosition){
        thisPhone.focus();
        thisPhone[0].selectionStart = thisPhone[0].selectionEnd = cursorPosition;
       }
      }
    }
  );
  
  function copyPaste(e){
    var thisPhone = $(this);
    var pastedData = e.originalEvent.clipboardData.getData('text');
    pastedData= pastedData.replaceAll('.','');
    if(pastedData.length > 10){
      var first10Digits = pastedData.slice(0,10);
      setTimeout(function(){
        thisPhone.val(first10Digits);
        thisPhone.trigger('keyup');
      }, 10);
    }
  }

  $(document).on('blur', '.demographicsCustomerPhoneNumber', function(e) {
    $(e.target).removeClass('error-msg-textbox');
    let patternMismatchEle = $(e.target)
      .parent()
      .find('.pattern-mismatch-text');
    let valueMissingEle = $(e.target)
      .parent()
      .find('.value-missing-text');

    //validity.valid does not work in IE11 so replaced the code for the same
    if (e.target.validity.valueMissing || e.target.validity.patternMismatch) {
      e.preventDefault();
      if (e.target.validity.patternMismatch && patternMismatchEle.length > 0) {
        if (!$(e.target).hasClass('new-account-phone')) {
          patternMismatchEle.attr('hidden', false);
        }
        valueMissingEle.attr('hidden', true);
      } else {
        valueMissingEle.attr('hidden', false);
        patternMismatchEle.attr('hidden', true);
      }
      $(e.target).addClass('error-msg-textbox');
      return false;
    }
    if (patternMismatchEle.length > 0) {
      patternMismatchEle.attr('hidden', true);
    }
    if (valueMissingEle.length > 0) {
      valueMissingEle.attr('hidden', true);
    }

    validatePhone();
  });
  $(document).on('paste','.demographicsCustomerPhoneNumber', copyPaste);
});
